import AWS from 'aws-sdk'
import { v4 as uuidv4 } from 'uuid'

const SPACES_BUCKET = process.env.REACT_APP_DIG_OCEAN_BUCKET
const SPACES_ENDPOINT = process.env.REACT_APP_DIG_OCEAN_ENDPOINT
const SPACES_KEY = process.env.REACT_APP_DIG_OCEAN_ACCESS_KEY
const SPACES_SECRET = process.env.REACT_APP_DIG_OCEAN_SECRET_ACCESS
const SPACES_REGION = process.env.REACT_APP_AWS_REGION || 'us-east-1'

// console.log({ SPACES_ENDPOINT, SPACES_BUCKET, SPACES_KEY, SPACES_SECRET, SPACES_REGION })

AWS.config.update({
  accessKeyId: SPACES_KEY,
  secretAccessKey: SPACES_SECRET,
  region: SPACES_REGION,
  signatureVersion: 'v4',
})

export const myBucket = new AWS.S3({
  endpoint: SPACES_ENDPOINT,
  region: SPACES_REGION,
  credentials: {
    accessKeyId: SPACES_KEY,
    secretAccessKey: SPACES_SECRET,
  }
})

export const uploadFileReturnFileNameUrl = async (file, setPhotoName, setUploadPercent) => {
  const fileType = file.name.split('.').pop()
  const fileName = `${uuidv4()}.${fileType}`

  setPhotoName(fileName)

  const params = {
    Bucket: SPACES_BUCKET,
    Key: fileName,
    Body: file,
    ContentType: file.type || 'application/octet-stream',
  }
  await myBucket
    .putObject(params)
    .on('httpUploadProgress', (evt) => setUploadPercent(Math.round((evt.loaded / evt.total) * 100)))
    .send((err, _data) => {
      if (err) {
        console.error('Upload error', err)
        return
      }
    })
  let fileUrl = await getFileLink(fileName)
  return ({ fileName, url: fileUrl })
}
export const uploadFile = async (file, setPhotoName, setUploadPercent) => {
  const fileType = file.name.split('.').pop()
  const fileName = `${uuidv4()}.${fileType}`

  // set photo name
  setPhotoName(fileName)

  // set parameters for putObject
  const params = {
    Bucket: SPACES_BUCKET,
    Key: fileName,
    Body: file,
    ContentType: file.type || 'application/octet-stream',
  }
  // upload file to S3 bucket
  await myBucket
    .putObject(params)
    .on('httpUploadProgress', (evt) => setUploadPercent(Math.round((evt.loaded / evt.total) * 100)))
    .send((err, _data) => {
      if (err) {
        console.error('Upload error', err)
        return
      }
      return fileName
    })

}

export const uploadFileSecond = async (data) => {
  const fileType = data.file.name.split('.').pop()
  const fileName = uuidv4() + '.' + fileType

  const params = {
    Bucket: SPACES_BUCKET,
    Key: fileName,
    Body: data.file,
    ContentType: data.file.type || 'application/octet-stream',
  }

  await myBucket
    .putObject(params)
    .on('httpUploadProgress', (evt) => console.info(Math.round((evt.loaded / evt.total) * 100)))
    .send((err, _data) => {
      if (err) console.error(err)
    })

  return fileName
}

// get link of file in S3 bucket using file name
export const getFileLink = async (filename) => {
  const signedUrl = myBucket.getSignedUrl('getObject', {
    Bucket: SPACES_BUCKET,
    Key: filename,
    Expires: 60 * 60 * 24 * 2, // 2 days
    // Expires: 60, // 1 minute
  })
  return signedUrl
}